import React from 'react';
import styled from 'styled-components';
import Text from 'components/Text';

type ReasonProps = {
  checked?: boolean;
  message?: string;
  onClick?: () => void;
};

const Reason = ({ checked, message, ...props }: ReasonProps) => {
  return (
    <div {...props} onClick={() => props.onClick?.()}>
      <ReasonStyled>
        {checked ? (
          <div className='checked-checkbox'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='31'
              height='30'
              viewBox='0 0 31 30'
              fill='none'
            >
              <path
                d='M12.6586 22.5C12.2584 22.5 11.8783 22.3326 11.5981 22.0396L5.93522 16.117C5.35493 15.5101 5.35493 14.5056 5.93522 13.8987C6.5155 13.2918 7.47598 13.2918 8.05627 13.8987L12.6586 18.7121L22.9437 7.95518C23.524 7.34827 24.4845 7.34827 25.0648 7.95518C25.6451 8.56209 25.6451 9.56662 25.0648 10.1735L13.7192 22.0396C13.439 22.3326 13.0588 22.5 12.6586 22.5Z'
                fill='white'
              />
            </svg>
          </div>
        ) : (
          <div className='blank-checkbox' />
        )}
        <Text variant='CONTENT_2' className='reason-text'>
          {message}
        </Text>
      </ReasonStyled>
    </div>
  );
};

export default Reason;

const ReasonStyled = styled.div`
  cursor: pointer;
  width: 100%;
  border-radius: 5px;
  &:hover {
    background-color: #ffe5e7 !important;
  }

  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;

  .reason-text {
    color: #1d2129;
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .blank-checkbox {
    display: flex;
    width: 40px;
    height: 40px;
    align-items: flex-start;
    gap: 10px;
    border-radius: 100px;
    border: 1px solid #86909c;
    background: #f5f5f5;
  }
  .checked-checkbox {
    display: flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 100px;
    border: 1px solid #2d6772;
    background: #2d6772;
  }
`;
